module.exports = __webpack_public_path__ + "img/_icon-red-alert.ecce32ac.svg";